import React from 'react';
import { Link } from 'react-router-dom';
import { NAV, SITE } from '../data/site';
import { LogoLockup } from './Logo';

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="container footer__grid">
      <div>
        <div className="footer__logo"><LogoLockup /></div>
        <p className="footer__muted">{SITE.tagline}. Medspa treatments and skin care designed to help you feel as good as you look.</p>
        <p className="footer__social">
          {SITE.social.map(s => <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer">{s.label}<span className="visually-hidden"> (opens in a new tab)</span></a>)}
        </p>
      </div>
      <div>
        <h2 className="footer__title">Explore</h2>
        <ul>
          {NAV.map(n => <li key={n.to}><Link to={n.to}>{n.label}</Link></li>)}
          <li><Link to="/reviews">Reviews</Link></li>
          <li><Link to="/faq">FAQ &amp; Aftercare</Link></li>
        </ul>
      </div>
      <div>
        <h2 className="footer__title">Visit</h2>
        <address>
          {SITE.address.map(l => <span key={l}>{l}<br /></span>)}
          <a href={`tel:${SITE.phone.replace(/[^\d+]/g, '')}`}>{SITE.phone}</a><br />
          <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
        </address>
        <ul className="footer__hours">
          {SITE.hours.map(h => <li key={h.days}><span>{h.days}</span><span>{h.time}</span></li>)}
        </ul>
      </div>
    </div>
    <div className="container footer__bar">
      <span>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</span>
      <span><Link to="/privacy-policy">Privacy Policy</Link> · <Link to="/terms">Terms</Link> · <Link to="/accessibility">Accessibility</Link></span>
      <span className="footer__credit">
        Site by <a href="https://www.ashbservicegroup.com/" target="_blank" rel="noopener noreferrer">ASHB Service Group<span className="visually-hidden"> (opens in a new tab)</span></a>
      </span>
    </div>
  </footer>
);

export default Footer;
